/*
 * Copyright (c) 2024. Amazon.com, Inc. or its affiliates. All rights reserved.
 */

export function hideMainLoader() {
    document.getElementById('mainLoader')?.classList.add('mainLoader--out')
}
